import createHashHistory from 'history/lib/createHashHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createHashHistory);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-router/es/hashHistory.js
// module id = OJIu
// module chunks = 1